import classNames from "classnames";
import { ButtonHTMLAttributes, MouseEvent, useCallback } from "react";
import { twMerge } from "tailwind-merge";

export function ControlPanel({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <div className={twMerge("shadow-depth-200 flex items-baseline rounded-lg bg-white", className)}>
      {children}
    </div>
  );
}

export function ControlButton({
  children,
  label,
  labelPlacement = "top",
  toggled = false,
  ...props
}: ButtonHTMLAttributes<HTMLButtonElement> & {
  label: string;
  labelPlacement?: "top" | "bottom";
  toggled?: boolean;
}) {
  const onClick = useCallback(
    (event: MouseEvent<HTMLButtonElement>) => {
      // Unfocus after clicking so tooltip hides when mousing away.
      event.currentTarget.blur();
      props.onClick?.(event);
    },
    [props.onClick],
  );

  return (
    <button
      {...props}
      aria-label={label}
      data-tooltip-placement={labelPlacement}
      onClick={onClick}
      className={twMerge(
        "text-charcoal-400 rounded-lg bg-white p-2 shadow-[inset_0_0_0_2px_#fff] transition-colors duration-200 ease-in-out hover:bg-black hover:bg-purple-100 hover:text-purple-600",
        "disabled:text-charcoal-400 disabled:cursor-not-allowed disabled:bg-[white] disabled:opacity-50",
        classNames({
          "bg-purple-100 text-purple-600": toggled,
        }),
        props.className,
      )}
    >
      {children}
    </button>
  );
}
